export const dictEnStep1 = {
  CalcTitle: 'Here you can:',
  MakeListItem1: 'Get a rate and time quote',
  MakeListItem2: 'Book a courier pickup online',
  MakeListItem3: 'Send from a DHL Service Point',
  CalcResultTitle: 'Please select one of the shipping options',
  Calculate: 'Calculate',
  CalculateRates: 'Calculate rates',
  CountryName: 'Russia',
  Country: 'Country',
  City: 'City',
  Postcode: 'Postcode',
  CountryOnlyError: 'The pickup location must be in Russian Federation',
  CountryNoAccess: 'Shipping from this country is not available at the moment',
  CountryNoAccessTo: 'Please choose Russia as the destination country',
  GetRates: 'Get rates',
  PickupFrom: 'Pick up from',
  DeliveryTo: 'Delivery to',
  SendingWhat: 'What are you sending?',
  PickUpTime: 'When to pick up?',
  Date: 'Date',
  Time: 'Time',
  TimeFrom: 'from',
  timeTo: 'to',
  CountryFrom: 'You can send shipments from Russian Federation only',
  CountryTo: 'Choose a country from the drop-down list',
  CountryToRUErrorMessage:
    'Delivery within Russia is not available at the moment',
  CountryToUAErrorMessage:
    'Delivery of goods and documents from Russia to the selected country is currently unavailable',
  CountryToBYErrorMessage:
    'Delivery of goods and documents from Russia to the selected country is currently unavailable',
  PostalCodeFrom: "Choose or check sender's postal code",
  PostalCodeTo: "Choose or check receiver's postal code",
  OnlyRf: 'You can send shipments from Russian Federation only',
  CountryPlaceholder: 'Enter country name',
  CityOrPostalCode: 'City or postcode',
  CityPlaceholder: 'Enter city name',
  PostcodePlaceholder: 'Enter postal code',
  nothingText: 'Sorry, but nothing found on your request',
  addPiece: 'Add shipment',
  Document: 'Document',
  DocumentType: 'Type of shipment: Documents of any type',
  Item: 'Shipment',
  ItemType: 'Type shipment for delivery: Shipment',
  PieceWeight: 'Weight',
  PieceHeight: 'Height',
  PieceDepth: 'Depth',
  PieceLength: 'Length',
  PieceWidth: 'Width',
  PieceWeightSI: 'Weight (kg)',
  PieceDimensions: 'Dimensions',
  PieceDimensionsSI: 'Dimensions, cm',
  PieceDimensionsDesc: 'in any order',
  Cancel: 'Cancel',
  Save: 'Save',
  Hint: 'Hint',
  Show: 'Show',
  Hide: 'Hide',
  PieceDimension: 'Piece Dimension',
  Service_Min_Weight: 'The minimum chargeable weight per piece is',
  Service_Max_Weight: 'The maximum weight per piece',
  InputRequired: 'Please fill in all dimensions',
  IntegerDims: 'Dimensions only integer',
  InputMinWeightExceeded: 'A minimum value should be more than',
  InputMaxExceeded: 'Maximum sizes should be less than 120x80x80cm',
  PickUpNoAvailableTimeTitle: 'Please select another day.',
  PickUpNoAvailableTime:
    'Unfortunately, we can’t arrange a pickup on the specified day. There might be no available time slots for a pickup or the selected destination is not available on this date. You must choose a different day to send your shipment',
  Or: 'or',
  ChooseOtherOptions: 'choose a different shipping option',
  PopularMethod: 'TOP choice',
  ShipmentTypeDelieveryDate: 'Expected delivery date:',
  ShipmentPlannedDeliveryTime: 'Estimated delivery date is',
  ShipmentPlannedDays: '0 business days | {n} business day | {n} business days',
  ShipmentTypeNeededAction: 'Your next steps:',
  ShipmentTypePayment: 'Payment options:',
  ShipmentTypeCash: 'Cash (payment by the sender only)',
  ShipmentTypeCardOnline:
    'By card online (payment by the receiver or a third party is available)',
  ShipmentTypeWalkCard: 'By card in the DHL office',
  ShipmentTypeCardTerminal:
    'By card to the courier (payment by the sender only)',
  ShipmentTypeDetails: 'Other Shipping Details',
  ShipmentTypeDetailsDesc:
    'Shipments that are not acceptable into the network for transportation, possible causes of delays, etc.',
  ShipmentTypeDetailsDescLink: 'Read more',
  ShipmentTypeVisit: 'Visit DHL office',
  ShipmentTypePrintAwb: 'Print out and hand over the airwaybill',
  ShipmentTypePrintAwbByShipper:
    'Create and print out the airwaybill (by the shipper)',
  ShipmentTypePrintAwbForOffice: 'Print out and bring the airwaybill with you',
  ShipmentTypePrintAwbForOfficePreparation: 'Preparing an invoice',
  ShipmentTypePrintAwbForOfficeNoPrint:
    'You do not need to print out the invoice',
  ShipmentTypeQuoteIsValid: 'The quote is valid if you print our airwaybill',
  ShipmentTypeWalkTitle: 'Drop-off at your local DHL office',
  ShipmentTypeWalkPriceDesc:
    'The special price is valid <b>when making an invoice online</b> and shipping from the DHL office',
  ShipmentTypeWalkProceed: 'Proceed with shipment',
  ShipmentTypeWalkConvenient: 'The most affordable option',
  ShipmentTypeWalkAffordable: 'Suitable for sending documents, and small and light shipments',
  ShipmentTypeWalkDropTime: 'Save your day - drop off the shipment at DHL Service Point and don\'t wait for a pickup',
  ShipmentTypeClickTitle: 'Book a pickup online',
  ShipmentTypeClickBalance: 'Best value for money',
  ShipmentTypeClickFast: 'The fastest way to book a pick-up',
  ShipmentTypeClickTime: 'Ideal for those who value their time',
  ShipmentTypeClickPriceDesc:
    '<div>The special price is valid when placing an order and calling a courier online.</div><div>It is necessary <b>to print the invoice yourself</b>.</div>',
  ShipmentTypeClickBook: 'Book Online',
  ShipmentTypePhoneTypeTitle: 'Book a pick-up by phone',
  ShipmentTypePhoneTypeEasy: 'Easy – just make a phone call',
  ShipmentTypePhoneTypeOperator:
    'Our Customer Service specialists will answer all your questions',
  ShipmentTypePhoneTypeConsultant:
    'Assistance with customs clearance, consultations on non-standard cargo',
  ShipmentTypePhoneTypePrieceDescr:
    'The quote is valid if you book a courier pickup by phone',
  ShipmentTypeWait: 'Wait for a DHL courier',
  ShipmentTypeWaitFromAbroad:
    'Wait for a phone call to the shipper to align the date and time for the pickup (within max 8 hours)',
  ShipmentTypeDiscount: 'Discount',
  CallCourierNow: 'Call',
  CallYourself: 'Or dial the phone number',
  Back: 'Back',
  ShipmentTypeModalTitle:
    'Check commodities information for destination country',
  ShipmentTypeModalDocuments: 'Accepted as documents',
  ShipmentTypeModalNonDocuments: 'Accepted as non-document shipments',
  FillingInternationalNonDoc: 'International non-document shipment',
  FillingInternationalNonDocDesc:
    'You have to create accompanying documents for your shipment. ' +
    'For consultation please call: ',
  FillingInternationalNonDocDescContinue:
    'You can continue registration of your shipment after the consultation is over by pressing OK button',
  ShipmentDetailed: 'Detailed info',
  RestrictedTitle: 'Prohibited and restricted commodities*',
  Responsibility:
    'Whenever possible DHL Express will provide service to you by transporting your shipments. However, a variety' +
    'of laws and regulations, as well as common-sense safety and security measures, prevent DHL from accepting certain commodities for transport.',
  ProhibitedItems: 'Prohibited',
  RestrictedItems: 'Restricted',
  Animals:
    'Animals, fish, birds (live) (Including mammals, reptiles, spiders, fish and birds).',
  Ashes:
    'Human remains or ashes in any form. This includes human embryos, placenta and ashes formed as gemstones.',
  Metal:
    'Precious metals and bullions (in ingots, coins, etc.); ' +
    'precious and semi-precious stones; articles of precious' +
    'metals and bullions, precious and semi-precious stones.',
  Cash: 'Cash (current legal tender) (bank notes, currency notes and coins).',
  Firearms:
    'Military items: firearms and edged weapons, ready for use for their intended purpose; explosives; ammunition; shells; cartridges; explosive devices containing substances that are resistant to storage and transportation, etc.; parts, mechanisms of firearms, accessories (sight, trigger, bolts and nuts, mounts, sights, night vision devices, butts, silencers, flashlights, magazines, flash silencers and unmasking devices, etc.); other military items subject to control/licensing (items “designed or modified for military use”, namely: spare parts for tanks and antiaircraft missiles, control panels, navigation equipment, control units, ammunition counters, fire control device, instrumentation sensors speed, spare parts and components designed or modified for military use, spare parts or equipment for aircraft and helicopters des gned or modified for military use, etc.).',
  Illegal:
    'Ivory and illegal goods. (Any goods considered to be illegal (as determined either by the exporting country, transit points, importing country or international law) are prohibited for carriage.' +
    'E.g. pornography, pirated goods, goods certain narcotics (heroin, cocaine), counterfeit products, smoking blends containing the following ingredients:' +
    'sage predictors (Salvia divinorum), hawaiian rose (Argyreia nervosa), blue lotus (Nymphaea caerulea).',
  Antiques:
    'Antiques and works of art (insured or uninsured, valued in excess of €500,000**). Regardless of value, if insured, customers must provide an independent proof of value in advance of collection.',
  Banderols: 'Banderols / tax stickers.',
  Cigarettes:
    'Cigarettes (both smoking and pipe tobacco, cigars, cigarillos), electronic cigarettes. (Necessary coordination with the department of Additional Services).',
  DangerousGoods:
    'Electrical shock equipment, guns with electrical shock, electric shockers or any other items capable of producing an electric discharge with the aim of causing harm, injury or temporary disablement (directly or indirectly intended for these purposes).',
  NegotiableInstruments:
    'Negotiable instruments in bearer form (whether cash-like or not). E.g. activated SIM cards for mobile telephones, blank or activated credit or cash dispenser cards, blank checks, event tickets whether cash-like or not, lottery tickets, money or postal orders, pre-paid phone cards, tickets (blank stock), Traveller’s Cheques, vouchers/tokens, unused stamps etc.',
  Furs: 'Furs.',
  Jewellery:
    'Jewellery without precious and semi-precious stones and metals for delivery within the country. Jewellery without precious and semi-precious stones and metals for international delivery if the price of the individual item is not more than € 5,000** total party value – not more than € 100 000**, not limited for transportation and accepted according to the custom regulations of the Russian Federation and DHL rules.',
  Watches:
    'Watches without precious metals. Individual items worth over 10,000 euros* for legal entities and worth over 10,000 euros** for individual item/total shipment value for private individuals.***',
  ToyGuns: 'Toy and pneumatic guns.',
  ReplicaFirearms:
    'Imitation or replica firearms, ammunition, explosives/explosive devices. Firearms parts. (Including all parts of firearms (e.g. rifle butts, sight, trigger mechanisms, screws/bolts etc.) manufactured for the sole purpose of creating a functional firearm). Objects that may potentially be used as a weapon, but this is not their direct purpose (kitchen knives), including decorative products (sabres, swords, etc.) are accepted for carriage without restrictions, but the sender shall attach the certificate /passport (with stamp), that the given object is not a cold weapon.***',
  RestrictedNotice1:
    'For more information on restricted commodities please contact your nearest DHL office.',
  RestrictedNotice2: 'Or equivalent in RUB.',
  RestrictedNotice3: 'Commodities are prohibited for import in Russia.',
  RestrictedNotice4:
    'For more information on debit and credit cards accepted, please contact your nearest DHL office',
  CorpClientTips:
    'If you are a corporate customer and hold DHL’s customer account, calculate the quote',
  CorpClientTipsLinkText: 'here',
  CorpClientTipsLink: 'https://mydhl.express.dhl/ru/en/auth/login.html',
  CorpClientTipsHint: 'you will need login and password to access your account',
  InvoiceCreate: 'Create an invoice',
  InvoiceHad: 'I have an invoice',
  LinkDeliveryAbroad: 'Delivery abroad for online stores',
  InfoMessage:
    'Dear customer! After calculating the tariff, please contact the online consultant or the customer service department to clarify the possibility of sending your cargo: tel. ',
  PaymentMethodsMessage:
    'There are no payment options available for this destination. Please contact the DHL contact center for details.',
};

export default {
  dictEnStep1,
};
